import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=51b7db4b&scoped=true"
import script from "./Listado.vue?vue&type=script&lang=js"
export * from "./Listado.vue?vue&type=script&lang=js"
import style0 from "./Listado.vue?vue&type=style&index=0&id=51b7db4b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b7db4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b7db4b')) {
      api.createRecord('51b7db4b', component.options)
    } else {
      api.reload('51b7db4b', component.options)
    }
    module.hot.accept("./Listado.vue?vue&type=template&id=51b7db4b&scoped=true", function () {
      api.rerender('51b7db4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/modulos/Listado.vue"
export default component.exports